import React from 'react';
import { motion } from 'framer-motion';

// Main tabular-nums countdown display, legible from 2 meters.
export const TimerDisplay = ({ seconds, pulse = false, color = '#FFFFFF' }) => {
  const s = Math.max(0, Math.round(seconds));
  return (
    <motion.div
      key={pulse ? `p-${s}` : undefined}
      animate={pulse ? { scale: [1, 1.12, 1] } : { scale: 1 }}
      transition={{ duration: 0.4 }}
      className="ns-timer leading-none"
      style={{ color }}
      aria-live="polite"
      aria-label={`${s} seconds remaining`}
    >
      {String(s).padStart(2, '0')}
    </motion.div>
  );
};

export default TimerDisplay;
